import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
import { Card, Flex, Heading, Button } from "@radix-ui/themes";
import { FiltersGetPaymentReferenceReportType } from "../../../types/Finance";
import { getPaymentReferenceReport } from "../../../services/finance/reports";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { PAGE_NUMBER, PAGE_SIZE } from "../../../utils/constants";
import { useGetPaymentTypesQuery } from "../../../hooks/useGetPaymentTypesQuery";


const statusOptions = [
  { value: "1", label: "Paga" },
  { value: "0", label: "Não Paga" },
];

const columnNamesMap: { [key: string]: string } = {
  paymentReference: "Referência",
  expectedAmount: "Valor",
  status: "Status",
  paymentType: "Tipo de emolumento",
};
const columnNamesMapTotal: { [key: string]: string } = {
    expectedAmount: "Valor",
  };

export const GetPaymentReferenceReport = () => {
        const [currentPage, setCurrentPage] = useState(1);
        const [pageSize, setPageSize] = useState(PAGE_SIZE); 
        const [searchTerm, setSearchTerm] = useState('');
  const { control, handleSubmit, watch, setValue, formState: { errors } } = useForm<FiltersGetPaymentReferenceReportType>({
    defaultValues: {
      ReferenceCode: "",
      IdPaymentType: "",
      IsPaid: '',
      PageNumber: currentPage,
      PageSize: pageSize,
    },
    mode: "onBlur",
  });

  const filters = watch(); 

  const memoizedFilters = useMemo(() => filters, [filters]);

  const { data, status, refetch } = useQuery(
    ["getPaymentReferenceReport", memoizedFilters],
    async () => await getPaymentReferenceReport(memoizedFilters),
    { keepPreviousData: true }
  );

  const onSubmit = handleSubmit(() => {
  });

  const handlePageChange = (page: number) => {
        setCurrentPage(page);
        setValue('PageNumber', page);
      };
      const handlePageSizeChange = (size: number) => {
        setPageSize(size);
        setCurrentPage(PAGE_NUMBER); 
        setValue('PageSize', size);
    };
  
    const handleSearch = (term: string) => {
        setSearchTerm(term);
        setValue('ReferenceCode', term)
        setCurrentPage(1); 
    };
          const { data: paymentTypesData, status: paymentTypesStatus, isError: isErrorPaymentTypes, isLoading: isLoadingPaymentTypes } = useGetPaymentTypesQuery({ PageNumber: 1, PageSize: 400 });
    
  return (
    <>
      <Card>
        <Flex gap="4" direction="column">
          <Heading>Relatório de Referências de Pagamento</Heading>
          <form onSubmit={onSubmit}>
            <Flex gap="4" direction="column">
              <Flex gap="2">
              <SelectComponent
                  name="IdPaymentType"
                  label="Tipo de emolumento"
                  control={control}
                  errors={errors}
                  options={paymentTypesData?.items.map((p) => ({
                    value: p.id ?? "",
                    label: p.description ?? "",
                  }))}
                  style={{ width: '100%' }}
                  itemsLoading={isLoadingPaymentTypes}
                />
                   <SelectComponent
                  name="IsPaid"
                  label="Estado"
                  control={control}
                  errors={errors}
                  options={statusOptions?.map((p) => ({
                    value: p.value ?? "",
                    label: p.label ?? "",
                  }))}
                  style={{ width: '100%' }}
                  itemsLoading={isLoadingPaymentTypes}
                />
              </Flex>
            </Flex>
          </form>
        </Flex>
      </Card>
      <Lists
        status={status}
        TableComponent={() => (
          <TableComponent
            columns={Object.keys(columnNamesMap)}
            items={data?.map((d: any) => ({
              ...d,
              status: d.status === 1 ? "Paga" : "Não Paga",
              paymentType: d.paymentType ?? "Nenhum Pagamento Feito",
            }))}
            columnNamesMap={columnNamesMap}
            totalPages={data?.totalPages || 1}
            onPageChange={handlePageChange}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange} 
            search={searchTerm}
            onSearch={handleSearch}
            currentPage={filters.PageNumber}
            totalItems={data?.totalItems}
            totalColumns={Object.keys(columnNamesMapTotal)}
            enableExportToExcel={true}
          />
        )}
      />
    </>
  );
};
